import { Modal } from '@components';
import { AttributesImport } from './AttributesImport';

import { AttributesImportModalProps } from './AttributesImportModal.props';

/**
 * AttributesImportModal component
 * @returns {JSX.Element}
 */

export const AttributesImportModal = ({
  businessUnit,
  businessUnitId,
  isModalOpen,
  onSuccess,
  onClose,
}: AttributesImportModalProps): JSX.Element => {
  return (
    <Modal open={!!isModalOpen} padding="0" onClose={onClose}>
      <AttributesImport
        businessUnit={businessUnitId}
        uniqueIdKey={businessUnit?.uniqueIdKey}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </Modal>
  );
};
